import React, { useState } from 'react';
import SearchBar from './searchBar';
import SearchResults from '../results/SearchResults';
import axios from 'axios';

const SearchPage = () => {
  const [searchMode, setSearchMode] = useState(true);
  const [recipes, setRecipes] = useState([]);
  const url =
    'https://api.spoonacular.com/recipes/findByIngredients?limitLicense=true&apiKey=1b4fe65ddf444934a7383294bdc90f6e&ingredients=';

  const searchRecipes = async (ingredients) => {
    axios
      .get(url + ingredients.toString())
      .then((res) => {
        const recipes = res.data;
        setRecipes(recipes);
        setSearchMode(false);
      })
      .catch((err) => console.error(err));
  };

  return (
    <div className="search">
      <SearchBar
        searchRecipes={searchRecipes}
        searchMode={searchMode}
        setSearchMode={setSearchMode}
      />
      {!searchMode ? <SearchResults recipes={recipes} /> : null}
    </div>
  );
};

export default SearchPage;
